<template>
	<v-dialog
		v-model="showDialog"
		scrollable="scrollable"
		max-width="800px"
		@click:outside="closeDialog"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white"
					>{{ selectedDate | dateFormatter }}　{{
						rubber ? rubber.name : ""
					}}の出庫情報</v-toolbar-title
				>

				<v-spacer></v-spacer>
				<v-btn icon dark color="white" @click="closeDialog">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet elevation="0" class="pa-2 scroll" min-height="150px">
				<v-sheet elevation="0" class="mt-4">
					<v-row justify="end">
						<!-- TODO 日付によるデータの編集・作成を厳密化する -->
						<v-btn v-if="authority" class="mr-6" color="secondary" @click="openShippingNewDialog">
							<v-icon>mdi-plus</v-icon>
							出庫の予定データを作成
						</v-btn>
					</v-row>
					<h5 class="text-h6 font-weight-bold color-secondary mb-1 mt-4">出庫先製品情報</h5>
					<!-- 予定出庫数 -->
					<div v-if="shippings.length">
						<table
							v-for="shipping in shippings"
							:key="shipping.id"
							width="100%"
							class="show-dialog-table mt-2 mb-5"
						>
							<tbody>
								<tr>
									<th width="30%" class="font-weight-bold">出庫対象製造番号</th>
									<td
										width="70%"
										v-if="
											shipping.order_target &&
											shipping.order_target.order_individual_info
										"
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										{{
											shipping.order_target.order_individual_info.get_product_info
										}}
										<v-btn
											text
											v-if="authority && shipping.situation == 'planned' && today < selectedDate"
											class="float-right"
											color="secondary"
											@click="openActualShippingNewDialog(shipping.id)"
										>
											<v-icon>mdi-plus</v-icon>
											出庫実績の作成
										</v-btn>
									</td>
									<td
										v-else
										width="70%"
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										対象製品はありません
										<v-btn
											text
											v-if="authority && shipping.situation == 'planned' && today < selectedDate"
											class="float-right"
											color="secondary"
											@click="openActualShippingNewDialog(shipping.id)"
										>
											<v-icon>mdi-plus</v-icon>
											出庫実績の作成
										</v-btn>
									</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">出庫予定数</th>
									<td
										width="70%"
										class="no-wrap"
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										{{ shipping.planned_quantity }}
										<v-icon
											v-if="authority && today < selectedDate"
											class="float-right"
											@click="
												openShippingEditDialog(shipping.id, shipping.planned_quantity, 'planned')
											"
											>mdi-pencil-box</v-icon
										>
									</td>
								</tr>
								<tr>
									<th width="30%" class="font-weight-bold">出庫予定日</th>
									<td
										width="70%"
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										{{ shipping.planned_operation_date | dateJaFormatter }}
										<v-icon
											v-if="authority && today < selectedDate"
											class="float-right"
											@click="
												openEditReceivingShippingDate(
													shipping.id,
													shipping.planned_operation_date,
													'planned'
												)
											"
											>mdi-pencil-box</v-icon
										>
									</td>
								</tr>
								<tr v-if="shipping.actual_quantity > 0" class="mt-1">
									<th width="30%" class="font-weight-bold">出庫実績</th>
									<td
										width="70%"
										class="no-wrap"
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										{{ shipping.actual_quantity }}
										<v-icon
											v-if="authority && today < selectedDate"
											class="float-right"
											@click="
												openShippingEditDialog(shipping.id, shipping.actual_quantity, 'actual')
											"
											>mdi-pencil-box</v-icon
										>
									</td>
								</tr>
								<tr v-if="shipping.actual_quantity > 0">
									<th width="30%" class="font-weight-bold">出庫日</th>
									<td
										width="70%"
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										{{ shipping.actual_operation_date | dateJaFormatter }}
										<v-icon
											v-if="authority && today < selectedDate"
											class="float-right"
											@click="
												openEditReceivingShippingDate(
													shipping.id,
													shipping.actual_operation_date,
													'actual'
												)
											"
											>mdi-pencil-box</v-icon
										>
									</td>
								</tr>
								<tr v-if="planned(shipping)">
									<th class="font-weight-bold" width="30%">状況</th>
									<td
										:class="{
											'text--violet': incomplete(shipping),
											'text--red': isNotShipped(shipping),
										}"
									>
										未出庫
									</td>
								</tr>
								<tr v-if="incomplete(shipping)">
									<th width="30%" class="font-weight-bold">状況</th>
									<td
										:class="{
											'text--violet': incomplete(shipping),
										}"
									>
										未完了
									</td>
								</tr>
								<tr v-if="complete(shipping)">
									<th width="30%" class="font-weight-bold">状況</th>
									<td>出庫済み</td>
								</tr>
								<tr>
									<td colspan="2" v-if="isNotShipped(shipping)" class="text--red">
										{{ notReceivedContent }}
									</td>
									<td colspan="2" v-if="incomplete(shipping)" class="text--red">
										{{ incompleteContent }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else>出庫情報はありません。</div>
				</v-sheet>
			</v-sheet>
		</v-card>
		<RubberPlannedShippingNewDialog
			:dialog.sync="showPlannedNewDialog"
			:authority="authority"
			:rubber="rubber"
			:selectedDate="selectedDate"
			:totalPlannedQuantity="shippingShowParams.totalPlannedQuantity"
			@reload-show="reloadNewShow"
		/>
		<RubberActualShippingNewDialog
			:dialog.sync="showActualNewDialog"
			:authority="authority"
			:rubber="rubber"
			:receiving_shipping_id="receiving_shipping_id"
			:totalPlannedQuantity="shippingShowParams.totalPlannedQuantity"
			:selectedDate="selectedDate"
			@reload-show="reloadActualNewShow"
		/>

		<RubberShippingEditDialog
			:dialog.sync="showEditDialog"
			:totalPlannedQuantity="shippingShowParams.totalPlannedQuantity"
			:selectedDate="selectedDate"
			:currentQuantity="currentQuantity"
			:shippingId="shippingId"
			:rubber="rubber"
			:quantityType="quantityType"
			:authority="authority"
			@reload-show="reloadUpdateShow"
		/>

		<RubberReceivingShippingDateEditDialog
			:dialog.sync="showDateEditDialog"
			:receivingShippingDate.sync="receivingShippingDate"
			:receivingShippingId="receivingShippingId"
			:dialogTitle="dialogTitle"
			:dateType="dateType"
			@reload-show="reloadUpdateShow"
		/>
	</v-dialog>
</template>

<script>
import RubberPlannedShippingNewDialog from "./RubberPlannedShippingNewDialog.vue"
import RubberActualShippingNewDialog from "./RubberActualShippingNewDialog.vue"
import RubberShippingEditDialog from "./RubberShippingEditDialog.vue"
import RubberReceivingShippingDateEditDialog from "./RubberReceivingShippingDateEditDialog.vue"
import moment from "moment"
import "moment/locale/ja"

export default {
	components: {
		RubberPlannedShippingNewDialog,
		RubberShippingEditDialog,
		RubberReceivingShippingDateEditDialog,
		RubberActualShippingNewDialog,
	},
	props: {
		shippingShowParams: {
			shippingPlannedQuantity: {
				type: Number,
				required: false,
			},
			totalPlannedQuantity: {
				type: Number,
				required: false,
			},
		},
		rubber: {
			type: Object,
			required: false,
			default: () => {},
		},
		receiving_shippings: {
			type: Array,
			required: false,
			default: () => [],
		},
		authority: {
			type: Boolean,
			required: false,
		},
		dialog: {
			type: Boolean,
			required: false,
		},
		selectedDate: {
			type: String,
			required: false,
		},
		today: {
			type: String,
			required: false,
		},
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
		dateJaFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月DD日(dd)")
		},
	},
	data() {
		return {
			showEditDialog: false,
			showPlannedNewDialog: false,
			showDateEditDialog: false,
			showActualNewDialog: false,
			shippings: [],
			planned_shippings: [],
			actual_shippings: [],
			disabled: true,
			shipping_planned_quantity: "",
			scrollable: false,
			receivingShippingDate: "",
			receivingShippingId: "",
			dialogTitle: "",
			shippingId: null,
			currentQuantity: null,
			receiving_shipping_id: null,
			quantityType: null,
			dateType: null,
			notReceivedContent: "※ 未出庫のまま期限が過ぎています。新しく予定を立ててください。",
			incompleteContent:
				"※ 出庫が未完了になっています。出庫実績を足すか新しく予定を立ててください。",
		}
	},
	mounted() {},
	methods: {
		setShippings(rubber, date, receiving_shippings) {
			this.shippings = receiving_shippings.filter((receiving_shipping) => {
				return (
					(receiving_shipping.planned_operation_date == date ||
						receiving_shipping.actual_operation_date == date) &&
					receiving_shipping.target_id == rubber.id &&
					receiving_shipping.movement_type == "shipping" &&
					(receiving_shipping.planned_quantity != 0 || receiving_shipping.actual_quantity != 0)
				)
			})
		},
		reloadNewShow(receiving_shipping) {
			this.shippings.push(receiving_shipping)
			this.$emit("reload-new-index", receiving_shipping)
		},
		reloadActualNewShow(receiving_shipping) {
			const index = this.shippings.findIndex((item) => item.id === receiving_shipping.id)
			if (index >= 0) {
				this.shippings.splice(index, 1, receiving_shipping)
			}
		},
		reloadUpdateShow(update_receiving_shipping, delete_receiving_shipping) {
			if (update_receiving_shipping) {
				this.update(update_receiving_shipping)
			} else {
				this.delete(delete_receiving_shipping)
			}
		},
		update(receiving_shipping) {
			this.setItem(receiving_shipping)
		},
		delete(receiving_shipping) {
			this.setItem(receiving_shipping)
			this.$emit("reload-delete-index", receiving_shipping.id)
		},
		setItem(receiving_shipping) {
			const index = this.shippings.findIndex((item) => item.id === receiving_shipping.id)
			if (index >= 0) {
				this.shippings.splice(index, 1, receiving_shipping)
			}
		},
		closeDialog() {
			this.showDialog = false
		},
		openShippingEditDialog(shipping_id, current_planned_quantity, quantityType) {
			this.showEditDialog = true
			this.shippingId = shipping_id
			this.currentQuantity = current_planned_quantity
			this.quantityType = quantityType
		},
		openShippingNewDialog() {
			this.showPlannedNewDialog = true
		},
		openActualShippingNewDialog(receiving_shipping_id) {
			this.showActualNewDialog = true
			this.receiving_shipping_id = receiving_shipping_id
		},
		openEditReceivingShippingDate(shipping_id, operation_date, dateType) {
			this.receivingShippingId = shipping_id
			this.receivingShippingDate = operation_date
			this.dialogTitle = "出庫日の編集"
			this.showDateEditDialog = true
			this.dateType = dateType
		},
		complete(shipping) {
			return shipping.planned_quantity - shipping.actual_quantity == 0
		},
		incomplete(shipping) {
			return shipping.actual_quantity !== 0 && shipping.planned_quantity > shipping.actual_quantity
		},
		planned(shipping) {
			return shipping.situation == "planned" && shipping.actual_quantity == 0
		},
		isNotShipped(shipping) {
			return shipping.situation == "planned" && this.today > this.selectedDate
		},
	},
	computed: {
		showDialog: {
			get() {
				if (this.dialog) {
					this.setShippings(this.rubber, this.selectedDate, this.receiving_shippings)
				}
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
table {
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.add-btn {
	text-align: right;
}

.scroll {
	overflow-y: scroll;
	overflow-x: hidden;
}
.text--violet {
	color: #8a2be2;
}
.text--red {
	color: red;
}
</style>
